import { render } from "./signup-success.vue?vue&type=template&id=2d3124e8"
import script from "./signup-success.vue?vue&type=script&lang=js"
export * from "./signup-success.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__